import http from 'plugins/axios';

export default {
  getTickers() {
    return http.post({
      url: '/la/admin/mytoken/searchTickers'
    });
  }
};
